import type { IAnnotationEngine } from './core/AnnotationEngine'
import { HTMLAnnotationEngine } from './core/HTMLAnnotationEngine'

export {
  ANNOTATION_CONFIDENCE_THRESHOLD,
  ANNOTATION_CONTEXT_LENGTH,
  ANNOTATION_HIGHLIGHT_CLASS,
} from './constants'
export type { IAnnotationEngine } from './core/AnnotationEngine'
export { AnnotationEngine } from './core/AnnotationEngine'
export { HTMLAnnotationEngine } from './core/HTMLAnnotationEngine'
export type {
  AnnotationMetadata,
  AnnotationSelectionEvent,
  AnnotationSelectionEventDetail,
  HTMLAnchorFragment,
  PDFAnchorFragment,
} from './types'
export * from './types.ts'
export { setupShadowDomSelectionHandler } from './utils'

export function createAnnotationEngine(
  root: Document | Element
): IAnnotationEngine {
  return new HTMLAnnotationEngine(root)
}
